export var EventType;
(function (EventType) {
    EventType["PAGE_VIEW"] = "page_view";
    EventType["USER_ACTION"] = "user_action";
    EventType["RECIPE_INTERACTION"] = "recipe_interaction";
    EventType["SEARCH"] = "search";
    EventType["CONVERSION"] = "conversion";
    EventType["ERROR"] = "error";
})(EventType || (EventType = {}));
